import { render, staticRenderFns } from "./PacientesAtendidos.vue?vue&type=template&id=36714cc4"
import script from "./PacientesAtendidos.vue?vue&type=script&lang=js"
export * from "./PacientesAtendidos.vue?vue&type=script&lang=js"
import style0 from "./PacientesAtendidos.vue?vue&type=style&index=0&id=36714cc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports